/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const PremiumPhone24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Custom Phone 24">
      <g className="Fill-Main">
        <path
          fill="#5E1FF0"
          d="M12 12.005h1.165v1.164H12v-1.164Zm1.915 2.744h.835v-.835h-.835v.835Zm0-4.658h.835v-.835h-.835v.835Zm-4.665 0h.835v-.835H9.25v.835Zm9.31 10.525v.125c-.07 1.265-1.085 2.264-2.37 2.33H7.94c-1.335 0-2.43-1.02-2.495-2.33V3.394c0-1.28.975-2.335 2.27-2.45l8.355-.01v-.01l.23.02c1.235.11 2.21 1.11 2.27 2.32v17.352h-.01ZM9 3.26c0 .414.335.75.75.75h4.5a.749.749 0 1 0 0-1.5h-4.5a.749.749 0 0 0-.75.75Zm.665 11.08H8.5v1.165h1.165V14.34Zm2.335 0h-1.165v1.165H12V14.34Zm3.5-1.17h-1.165v-1.164H13.17V10.84h-1.165v1.165H10.84v1.164h1.165v1.165h1.165v1.165h2.335v-2.335l-.005.005Zm0-2.329V8.506H12v1.16h-1.165v-1.16H8.5v2.334h1.165v1.165H8.5v1.164h1.165v1.165h1.165v-1.165H9.665v-1.164h1.165V10.84H12V9.666h1.165v1.174h1.17v1.17H15.5v-1.17Z"
        />
        <path
          fill="#fff"
          fillOpacity={0.8}
          d="M12 12.005h1.165v1.164H12v-1.164Zm1.915 2.744h.835v-.835h-.835v.835Zm0-4.658h.835v-.835h-.835v.835Zm-4.665 0h.835v-.835H9.25v.835Zm9.31 10.525v.125c-.07 1.265-1.085 2.264-2.37 2.33H7.94c-1.335 0-2.43-1.02-2.495-2.33V3.394c0-1.28.975-2.335 2.27-2.45l8.355-.01v-.01l.23.02c1.235.11 2.21 1.11 2.27 2.32v17.352h-.01ZM9 3.26c0 .414.335.75.75.75h4.5a.749.749 0 1 0 0-1.5h-4.5a.749.749 0 0 0-.75.75Zm.665 11.08H8.5v1.165h1.165V14.34Zm2.335 0h-1.165v1.165H12V14.34Zm3.5-1.17h-1.165v-1.164H13.17V10.84h-1.165v1.165H10.84v1.164h1.165v1.165h1.165v1.165h2.335v-2.335l-.005.005Zm0-2.329V8.506H12v1.16h-1.165v-1.16H8.5v2.334h1.165v1.165H8.5v1.164h1.165v1.165h1.165v-1.165H9.665v-1.164h1.165V10.84H12V9.666h1.165v1.174h1.17v1.17H15.5v-1.17Z"
        />
      </g>
      <path
        fill="#000"
        d="M16.33.02 16.06 0v.01H7.94V0l-.27.02C5.95.15 4.59 1.524 4.5 3.224v17.392C4.5 22.481 6.04 24 7.935 24h8.125c1.895 0 3.435-1.52 3.44-3.384V3.394c0-1.755-1.39-3.24-3.17-3.374Zm2.23 20.721c-.065 1.265-1.085 2.264-2.37 2.33H7.94c-1.335 0-2.43-1.02-2.495-2.33V3.394c0-1.28.975-2.334 2.27-2.45l8.355-.01v-.01l.23.02c1.235.11 2.21 1.11 2.27 2.32V20.74h-.01ZM9 3.26c0-.415.335-.75.75-.75h4.5a.749.749 0 1 1 0 1.5h-4.5A.749.749 0 0 1 9 3.26Zm.665 8.746v1.164h1.165v1.165H9.665V13.17H8.5v-1.164h1.165Zm4.665 0h-1.165V10.84H12v1.165h-1.165v1.164H12v1.165h1.165v1.165H15.5v-2.335h-1.165V12l-.005.005Zm-1.165 1.164H12v-1.164h1.165v1.164Zm1.585.75v.835h-.835v-.83h.835v-.005Zm-3.915.42H12v1.165h-1.165V14.34Zm4.665-3.798V8.506H12v1.16h-1.165v-1.16H8.5v2.335h1.165v1.164h1.165V10.84H12V9.667h1.165v1.175h1.17v1.169H15.5v-1.469Zm-5.415-.45H9.25v-.835h.835v.835Zm4.665 0h-.835v-.835h.835v.835ZM8.5 14.339h1.165v1.165H8.5v-1.165Z"
        className="Details"
      />
    </g>
  </svg>
);
const PremiumPhone48 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <g className="Custom Phone 49">
      <g className="Fill-Main">
        <path
          fill="#5E1FF0"
          d="M24 24.01h2.33v2.329H24v-2.33Zm3.83 5.488h1.67v-1.67h-1.67v1.67Zm0-9.317h1.67v-1.669h-1.67v1.67Zm-9.33 0h1.67v-1.669H18.5v1.67Zm18.62 21.052v.25c-.14 2.529-2.17 4.528-4.74 4.658h-16.5c-2.67 0-4.86-2.04-4.99-4.658V6.787c0-2.559 1.95-4.668 4.54-4.898l16.71-.02v-.02l.46.04c2.47.22 4.42 2.22 4.54 4.638v34.706h-.02ZM18 6.517c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5Zm1.33 22.16H17v2.33h2.33v-2.33Zm4.67 0h-2.33v2.33H24v-2.33Zm7-2.338h-2.33v-2.33h-2.33v-2.328h-2.33v2.329h-2.33v2.329h2.33v2.329h2.33v2.329h4.67v-4.668l-.01.01Zm0-4.658v-4.668h-7v2.319h-2.33v-2.32H17v4.669h2.33v2.329H17v2.329h2.33v2.329h2.33v-2.33h-2.33V24.01h2.33v-2.33H24v-2.348h2.33v2.349h2.34v2.339H31v-2.34Z"
        />
        <path
          fill="#fff"
          fillOpacity={0.8}
          d="M24 24.01h2.33v2.329H24v-2.33Zm3.83 5.488h1.67v-1.67h-1.67v1.67Zm0-9.317h1.67v-1.669h-1.67v1.67Zm-9.33 0h1.67v-1.669H18.5v1.67Zm18.62 21.052v.25c-.14 2.529-2.17 4.528-4.74 4.658h-16.5c-2.67 0-4.86-2.04-4.99-4.658V6.787c0-2.559 1.95-4.668 4.54-4.898l16.71-.02v-.02l.46.04c2.47.22 4.42 2.22 4.54 4.638v34.706h-.02ZM18 6.517c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5Zm1.33 22.16H17v2.33h2.33v-2.33Zm4.67 0h-2.33v2.33H24v-2.33Zm7-2.338h-2.33v-2.33h-2.33v-2.328h-2.33v2.329h-2.33v2.329h2.33v2.329h2.33v2.329h4.67v-4.668l-.01.01Zm0-4.658v-4.668h-7v2.319h-2.33v-2.32H17v4.669h2.33v2.329H17v2.329h2.33v2.329h2.33v-2.33h-2.33V24.01h2.33v-2.33H24v-2.348h2.33v2.349h2.34v2.339H31v-2.34Z"
        />
      </g>
      <path
        fill="#000"
        d="M32.66.04 32.12 0v.02H15.88V0l-.54.04C11.9.3 9.18 3.049 9 6.447v34.786C9 44.96 12.08 48 15.87 48h16.25c3.79 0 6.87-3.039 6.88-6.767V6.787C39 3.28 36.22.31 32.66.04Zm4.46 41.443c-.13 2.529-2.17 4.528-4.74 4.658h-16.5c-2.67 0-4.86-2.04-4.99-4.658V6.787c0-2.559 1.95-4.668 4.54-4.898l16.71-.02v-.02l.46.04c2.47.22 4.42 2.22 4.54 4.638v34.956h-.02ZM18 6.517c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5Zm1.33 17.493v2.329h2.33v2.33h-2.33v-2.33H17V24.01h2.33Zm9.33 0h-2.33v-2.329H24v2.329h-2.33v2.329H24v2.33h2.33v2.328H31V26.33h-2.33V24l-.01.01Zm-2.33 2.329H24V24.01h2.33v2.329Zm3.17 1.5v1.669h-1.67v-1.66h1.67v-.01Zm-7.83.84H24v2.328h-2.33v-2.329ZM31 21.08v-4.068h-7v2.319h-2.33v-2.32H17v4.669h2.33v2.329h2.33V21.68H24v-2.35h2.33v2.35h2.34v2.339H31V21.08Zm-10.83-.9H18.5v-1.669h1.67v1.67Zm9.33 0h-1.67v-1.669h1.67v1.67ZM17 28.679h2.33v2.33H17v-2.33Z"
        className="Details"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: PremiumPhone24,
  md: PremiumPhone24,
  lg: PremiumPhone24,
  xl: PremiumPhone48,
  xxl: PremiumPhone48,
  xxxl: PremiumPhone48,
};

export const PremiumPhoneIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'premium-phone-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
